/**
 * Redirige vers la home si l'utilisateur est pas authentifié (pour l'écran de connexion)
 */

import { useAuthStore } from "@/store/auth";

export default defineNuxtRouteMiddleware((to) => {
  const { $pinia } = useNuxtApp();
  const authStore = useAuthStore($pinia);
  if (authStore.isLogged) {
    return navigateTo("/");
  }

  return;
})
